module.exports = __webpack_public_path__ + "img/wx-code.60536bf5.png";